export default __webpack_public_path__ + "static/media/FD3.b0388eb5.pdf";